import { useState } from "react";
import {
    FromContainer,    
    PaletteSection,
    PaletteGrid,
    PaletteColor,
    SectionHeader,
    SectionTitleLabel,
    DividerText,
    NoColorSelected,
    HelperText,
    FooterActions,    
} from "./style";
import { WebcamCapture } from "./webcam-capture";
import { InputText, ButtonOpacity, ButtonPrimary, DescriptionBody, TitleBody } from "../../../common";
import { IoCameraOutline } from "react-icons/io5";

const PALETTE_COLORS = [
    "#e53935", "#d32f2f", "#c62828", "#b71c1c", "#ff5722", "#f44336",
    "#fb8c00", "#ff9800", "#ffa726", "#ffb74d", "#fdd835", "#fbc02d",
    "#f9a825", "#f57f17", "#7cb342", "#8bc34a", "#9e9d24", "#558b2f",
    "#43a047", "#66bb6a", "#26a69a", "#00897b", "#00acc1", "#0097a7",
    "#1e88e5", "#2196f3", "#42a5f5", "#5c6bc0", "#3949ab", "#3f51b5",
    "#8e24aa", "#7b1fa2", "#ab47bc", "#ec407a", "#e91e63", "#ad1457",
    "#757575", "#616161", "#424242", "#212121", "#ffffff"
];

interface FormCreateWorkoutProps {
    onSubmit: (color: string, description: string) => void;
    loading: boolean;
}

export const FormCreateAction: React.FC<FormCreateWorkoutProps> = ({ onSubmit, loading }) => {
    const [color, setColor] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [isWebcamOpen, setIsWebcamOpen] = useState(false);

    const onClickSave = () => {
        onSubmit(color, description);
    }

    const handleColorCapture = (colorHex: string) => {
        PALETTE_COLORS.push(colorHex);
        setColor(colorHex);
        setIsWebcamOpen(false);
    }

    return (
        <FromContainer>
            <TitleBody>Criar estímulo</TitleBody>
            <DescriptionBody margintop="-10px">
                Associe uma cor a uma ação física para usar durante o treino.
            </DescriptionBody>

            <SectionHeader>
                <SectionTitleLabel>COR DO ESTÍMULO</SectionTitleLabel>
            </SectionHeader>

            <ButtonOpacity
                width="100%"
                margintop="0px"
                marginbottom="0px"
                onClick={() => setIsWebcamOpen(true)}>
                <IoCameraOutline size={25} style={{ marginRight: "10px" }} /> Capturar cor com a câmera
            </ButtonOpacity>

            <DividerText>ou escolha na paleta</DividerText>

            <PaletteSection>
                <PaletteGrid>
                    {PALETTE_COLORS.map((hex) => {
                        const isSelected = color.toLowerCase() === hex.toLowerCase();
                        return (
                            <>
                            
                                <PaletteColor
                                    key={hex}
                                    $color={hex}
                                    $selected={isSelected}                                    
                                    type="button"
                                    onClick={() => setColor(hex)}
                                    title={hex}
                                />
                            </>
                        )
                    })}
                </PaletteGrid>
            </PaletteSection>

            <WebcamCapture
                isOpen={isWebcamOpen}
                onClose={() => setIsWebcamOpen(false)}
                onCapture={handleColorCapture}
            />

            {!color && (
                <NoColorSelected>
                    Nenhuma cor selecionada. Toque em uma das cores acima ou capture com a câmera.
                </NoColorSelected>
            )}            
            <InputText
                label="Ação associada"
                placeholder="Ex: encostar no cone amarelo"
                onChange={(e) => setDescription(e.target.value)}
                value={description}
                color="#fff" />

            <HelperText>
                Descreva o movimento que o atleta deve executar quando esta cor aparecer no monitor.
            </HelperText>

            <FooterActions>
                <ButtonPrimary
                    margintop="0"
                    marginbottom="0"
                    width="100%"
                    disabled={!color || !description}
                    loading={loading}
                    onClick={onClickSave}
                >
                    Salvar estímulo
                </ButtonPrimary>
            </FooterActions>
        </FromContainer>
    )
}